<template>
  <div id="nav">
    <v-toolbar flat fixed>
      <v-btn icon @click="drawer = !drawer" class="hidden-md-and-up">
        <v-icon>menu</v-icon>
      </v-btn>
      <v-toolbar-title>
        <router-link to="/">
          <img class="builder-logo" src="../../static/images/Dealer-Draft_logo.png">
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <router-link to="/builder">
          <v-btn flat>Home Build</v-btn>
        </router-link>
        <router-link :to="{ name: 'SRPBuilder' }">
          <v-btn flat>SRP Build</v-btn>
        </router-link>
      </v-toolbar-items>
    </v-toolbar>
    <v-navigation-drawer v-model="drawer" fixed temporary>
      <v-list>
        <v-list-tile to="/builder">
          <v-list-tile-title>Home Build</v-list-tile-title>
        </v-list-tile>
        <v-list-tile to="/srp-builder">
          <v-list-tile-title>SRP Build</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawer: false,
    };
  },
}
</script>

<style scoped>
  .builder-logo {
    max-height: 40px;
  }
  #nav {
    height: 64px;
  }
  .mobile-nav {
    width: 250px;
  }
  @media (max-width: 575px) {
    .builder-logo {
      max-height: 30px;
    }
    .v-btn {
      font-size: 12px;
      padding: 0 12px;
    }
  }
  @media (max-width: 450px) {
    .builder-logo {
      max-height: 20px;
    }
    .v-toolbar__title:not(:first-child) {
      margin-left: 0;
    }
    .v-btn {
      font-size: 10px;
      padding: 0 8px;
      min-width: auto;
    }
  }
</style>